// Libs
import React from 'react';
import { Banner, Button } from '@neptune/shared/venus-ui';

// App
import { UpgradePlanLink } from './UpgradePlanLink';

// Module
type InvitationsLimitReachedNoticeProps = {
  workspaceName: string;
};

export const InvitationsLimitReachedNotice: React.FC<InvitationsLimitReachedNoticeProps> = ({
  workspaceName,
}) => {
  return (
    <Banner.Warning>
      <span>
        You’ve reached the limit of invitations. To add more members, increase the number of seats
        or upgrade your plan.{' '}
        <UpgradePlanLink workspaceName={workspaceName}>
          <Button variant="primary">Manage your plan</Button>
        </UpgradePlanLink>
      </span>
    </Banner.Warning>
  );
};
